module.exports = __webpack_public_path__ + "media/images/athletes/2463-55d4ca382f78073446ebe33845eba324.png";